<template>
  <div></div>
</template>

<!-- API变量 -->
<script>
const state = 1;
let localSrc = "";
let agent_Id = "";
let app_Id = "";

(state => {
  switch (state) {
    case 1:
      localSrc = process.env.API_HOST; // 测试 接口地址
      agent_Id = process.env.AGENT_ID;
      app_Id = process.env.APP_ID;
      break;
    case 2:
      // localSrc = ''
      break;
    case 3:
      // localSrc = ''
      break;
    case 4:
      // localSrc = ''
      break;
  }
  // if (state === 1) {
  //   console.log('api:' + state)
  //   localSrc = 'https://apphr.i.sinotrans.com/dev' // 测试 接口地址
  // } else if (state === 2) {
  //   localSrc = ''
  // } else if (state === 3) {
  //   localSrc = ''
  // } else if (state === 4) {
  //   localSrc = ''
  // }
})(state);

export default {
  localSrc: localSrc,
  app_Id: app_Id,
  agent_Id: agent_Id,
  mobileApiHost: process.env.MOBILE_API_HOST,
  admin_role_no: "01123-role-manager-hr",
  newApiHost: process.env.NEW_API_HOST,
  newApiHostAuth: process.env.NEW_API_HOST_AUTH,
  systemCode: '01123'
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/Global.vue